import { render, staticRenderFns } from "./InfosAffaireTop.vue?vue&type=template&id=1f348680&scoped=true&"
import script from "./InfosAffaireTop.vue?vue&type=script&lang=js&"
export * from "./InfosAffaireTop.vue?vue&type=script&lang=js&"
import style0 from "./InfosAffaireTop.vue?vue&type=style&index=0&id=1f348680&scoped=true&lang=css&"
import style1 from "./InfosAffaireTop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f348680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f348680')) {
      api.createRecord('1f348680', component.options)
    } else {
      api.reload('1f348680', component.options)
    }
    module.hot.accept("./InfosAffaireTop.vue?vue&type=template&id=1f348680&scoped=true&", function () {
      api.rerender('1f348680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/affaire/components/InfosAffaireTop.vue"
export default component.exports